import { createFileRoute, redirect } from '@tanstack/react-router';
import { featureFlags } from '@/lib/env';

/**
 * 旧 URL 互換: 設問エディタは /it-operation-core/config/$patternId に統合済み。
 */
export const Route = createFileRoute('/_staff/it-operation-core/self-report-patterns/$patternId/')({
  beforeLoad: ({
    params
  }) => {
    if (!featureFlags.check('ENABLE_IN_HOUSE_OPERATION_PACKAGE')) {
      throw redirect({
        to: '/it-operation-core/packages'
      });
    }
    throw redirect({
      to: '/it-operation-core/config/$patternId',
      params: {
        patternId: params.patternId
      }
    });
  }
});